/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import AddPermissionTabContent from './AddPermissionTabContent';
// import { TextField, InputAdornment, Box, Tabs, Tab, Checkbox, Grid, FormGroup, FormControlLabel } from '@mui/material';
// import MUICheckbox from '../MUICheckbox/MUICheckbox';

interface IMenuData {
    menuId: number;
    roleId: number;
    sortOrder: number;
    isDisplay: boolean;
    menuName: string;
    menuFeaturePermissions: MenuFeaturePermission[];
  }
  
interface MenuFeaturePermission {
    menuFeatureId: number;
    menuFeature: string;
    hasPermission: boolean;
  }

interface SelectedMenuId {
    menuFeatureId: number;
  }

interface PermissionTabProps {
    page: string;
    menuData: IMenuData[];
    closeModal: any;
    onMenuFeatureSelect: (menuFeatureId: any, checked: boolean) => void;
    selectedMenuFeatureIds: number[];
    setSelectedMenuFeatureIds: React.Dispatch<React.SetStateAction<number[]>>;
}

function AddPermissionTab({ menuData, onMenuFeatureSelect, selectedMenuFeatureIds, setSelectedMenuFeatureIds }: PermissionTabProps): JSX.Element {
    // const roleId = sessionStorage.getItem('roleId') ?? '';
    const [selectedMenuIds, setSelectedMenuIds] = useState<SelectedMenuId[]>([]);
    //@ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [selectAllChecked, setSelectAllChecked] = useState(false);

    const onItemSelect = (menuObj: SelectedMenuId, checked: boolean, menuType: string): void => {
        if (checked) {
            if(menuType === "main") {
                setSelectedMenuIds([...selectedMenuIds, menuObj]);
                const data = menuData.filter(item => item.menuId === menuObj.menuFeatureId);
                const selectedIds:any = []
                data[0].menuFeaturePermissions.map(item => {
                    console.log("menuData===x", item)
                    selectedIds.push(item.menuFeatureId)
                    
                })
                onMenuFeatureSelect(selectedIds, checked);
            }
            if(menuType === "sub") {
                setSelectedMenuFeatureIds([...selectedMenuFeatureIds, menuObj.menuFeatureId]);
            }
        } else {
            
            if(menuType === "main") {
                const a = selectedMenuIds.filter(item => item.menuFeatureId !== menuObj.menuFeatureId)
                setSelectedMenuIds(a);

                const data = menuData.filter(item => item.menuId === menuObj.menuFeatureId);

                const selectedIds:any = []
                data[0].menuFeaturePermissions.map(item => {
                    console.log("menuData===x", item)
                    selectedIds.push(item.menuFeatureId)
                    
                })
                
                onMenuFeatureSelect(selectedIds, checked);
            }
            if(menuType === "sub") {
                const b = selectedMenuFeatureIds.filter(id => id !== menuObj.menuFeatureId)
            
                setSelectedMenuFeatureIds(b);
            }
            
        }
        if(menuType === "sub") {
            onMenuFeatureSelect([menuObj.menuFeatureId], checked);
        }
    };

    return (
        <div>
            <div className='px-[16px] pt-[10px] mb-[60px]'>
                {menuData.map((menu) => {
                    
                    return (
                    <AddPermissionTabContent
                        key={menu.menuId}
                        menuData={menu}
                        onItemSelect={(menuObj, checked, menuType) => onItemSelect(menuObj, checked, menuType)}
                        selected={selectedMenuIds.some(item => item.menuFeatureId === menu.menuId)}
                        selectAllChecked={selectAllChecked} // Pass selectAllChecked prop
                        selectedMenuFeatureIds={selectedMenuFeatureIds}
                    />
                )
                })}
            </div>
        </div>
    );
}
export default AddPermissionTab;
